import { Alert, Button } from "@mui/material";
import React, { useState } from "react";
import Modal from "../elements/Modal";
import CategoryForm from "./CategoryForm"; 

export function EditSurveyCategory({
  category,
  fetchData,
  setMessage,
  setSnackbarOpen,
  token,
}) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  const handleSubmit = async (values) => {
    setError(null);
    setLoading(true);
    try {      
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/v2/survey/category/${category.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({ category: { name: values.name } }),
        }
      );

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(
          errorResponse.error?.message || "Failed to update category"
        );
      }

      setMessage("Category updated successfully");
      setSnackbarOpen(true);
      handleClose();
      
      await fetchData();
    } catch (error) {
      setError(`Failed to update category: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="text"
        sx={{ cursor: "pointer", textTransform: "none", fontSize: "inherit" }}
        onClick={handleClickOpen}
      >
        Edit Category
      </Button>

      <Modal
        open={open}
        width="sm"
        modalTitle="Edit Category"
        handleClose={handleClose}
      >
        {error && <Alert severity="error">{error}</Alert>}
        <CategoryForm
          category={{ name: category.category }}
          onSubmit={handleSubmit}
          loading={loading}
        />
      </Modal>
    </>
  );
}

export default EditSurveyCategory;